/**
 * Formats delivery date to human-readable format
 * @param date - Date to format
 * @param capitalize - Whether to capitalize the first letter
 * @returns Formatted date string
 */
export function formatDeliveryDate(date: string | Date, capitalize = false): string | null {
  if (!date) return null;
  
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  
  const target = new Date(date);
  target.setHours(0, 0, 0, 0);
  
  const diffTime = target.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    return capitalize ? 'Сегодня' : 'сегодня';
  } else if (diffDays === 1) {
    return capitalize ? 'Завтра' : 'завтра';
  } else {
    // Format as "15 марта"
    const months = [
      'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
      'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];
    
    const day = target.getDate();
    const month = months[target.getMonth()];
    
    return `${day} ${month}`;
  }
}

/**
 * Formats delivery date with fallback to "завтра" if date is invalid
 * @param date - Date to format
 * @param capitalize - Whether to capitalize the first letter
 * @returns Formatted date string with fallback
 */
export function formatDeliveryDateWithFallback(date: any, capitalize = false): string {
  if (!date) return capitalize ? 'Завтра' : 'завтра';
  return formatDeliveryDate(date, capitalize) || (capitalize ? 'Завтра' : 'завтра');
}

/**
 * Formats only nearest delivery dates (today/tomorrow), returns null for other dates
 * @param date - Date to format
 * @returns Formatted date string or null
 */
export function formatOnlyNearestDeliveryDate(date: string | Date): string | null {
  if (!date) return null;
  
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  
  const target = new Date(date);
  target.setHours(0, 0, 0, 0);
  
  const diffTime = target.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    return 'сегодня';
  } else if (diffDays === 1) {
    return 'завтра';
  } else {
    return null;
  }
}
